import { ButtonPrimary, ButtonTertiary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { FlightSidePanelDetails } from "./FlightSidePanelDetails";

export interface FlightSidePanelProps {
  flightSegmentId: number
  trigger: JSX.Element
}

export const FlightSidePanel = (props: FlightSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.Api.Flights.GetFlightBySegment(props.flightSegmentId)}
    apiKey="flight-segment"
    entityId={props.flightSegmentId}
    title={RESX.Flight.resxFlight}
    footerContent={flight => <>
      <ButtonPrimary href={routes.flight_Detail(flight.id).absolute} label={RESX.Buttons.DetailView} />
      {flight.permissions.canModify && <ButtonTertiary
        onClick={() => SystemOneLibrary.exports.openFlightEditModal(props.flightSegmentId)}
        label={RESX.Buttons.btnEdit}
      />}
    </>}
    trigger={props.trigger}
  >
    {(flight) => <FlightSidePanelDetails
      flight={flight}
      flightSegmentId={props.flightSegmentId}
    />}
  </DetailSidePanel>
};